import { useState } from 'react'
import { TopNavigation } from '../components/TopNavigation'
import { QueryConsole } from '../components/RAGMaster/QueryConsole'
import { ObservabilityCenter } from '../components/RAGMaster/ObservabilityCenter'
import { OperationsCenter } from '../components/RAGMaster/OperationsCenter/index'
import { RolloutManager } from '../components/RAGMaster/RolloutManager'

type TabId = 'query' | 'observability' | 'operations' | 'rollout'

export function RAGMasterPage() {
    const [activeTab, setActiveTab] = useState<TabId>('query')
    const [targetTraceId, setTargetTraceId] = useState<string | undefined>(undefined)

    const handleInspectTrace = (traceId: string) => {
        setTargetTraceId(traceId)
        setActiveTab('observability')
    }

    const tabs = [
        { id: 'query' as TabId, label: 'Query Console', icon: '🔍' },
        { id: 'observability' as TabId, label: 'Observability', icon: '📊' },
        { id: 'operations' as TabId, label: 'Operations', icon: '⚙️' },
        { id: 'rollout' as TabId, label: 'Rollout', icon: '🚀' },
    ]

    return (
        <div className="flex flex-col h-screen bg-black">
            <TopNavigation />

            <div className="flex-1 flex flex-col overflow-hidden">
                {/* Header */}
                <div className="border-b border-white/10 px-8 py-6">
                    <h1 className="text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-500">
                        RAG Master Control
                    </h1>
                    <p className="text-gray-400 text-sm mt-1">
                        Sistema de gerenciamento e monitoramento do RAG
                    </p>
                </div>

                {/* Tabs */}
                <div className="border-b border-white/10 px-8">
                    <div className="flex gap-2">
                        {tabs.map((tab) => (
                            <button
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id)}
                                className={`px-6 py-3 text-sm font-medium transition-all ${activeTab === tab.id
                                    ? 'text-white border-b-2 border-blue-500'
                                    : 'text-gray-400 hover:text-gray-300'
                                    }`}
                            >
                                <span className="mr-2">{tab.icon}</span>
                                {tab.label}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Content */}
                <div className="flex-1 overflow-auto p-8">
                    {activeTab === 'query' && <QueryConsole onInspectTrace={handleInspectTrace} />}
                    {activeTab === 'observability' && <ObservabilityCenter initialTraceId={targetTraceId} />}
                    {activeTab === 'operations' && <OperationsCenter />}
                    {activeTab === 'rollout' && <RolloutManager />}
                </div>
            </div>
        </div>
    )
}
